import React, { useState, useRef, useEffect } from "react";

// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge, Modal,ModalHeader, ModalBody,Table,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import { useSelector , useDispatch} from 'react-redux'
import ReactTables from "./FeaturesList";
import {fieldvalidator, filenamevalid, alphanum, alpha, numtests, numdtest,
    floattest, numtest} from '../../../../helpers/validate'
import {customStyles} from '../../../../helpers/mycomps'

import Select from "react-select";
import dp from "../../../images/fet.png"
import FeaturesList from './FeaturesList'


//import { areaFetch, featureFetch} from "../../../../actions/actions"

import { areaFetch, featureFetch} from "../../../../actions/actions"
function Features(props) {
 var dispatch = useDispatch()
    const hiddenFileInput = useRef(null);
    
  //  const storfeature  = useSelector(state => state.featureStore.featureData)
    const catlist  = useSelector(state => state.featureStore.featureData).map(x => {
    return {
          label :x.categoryName.en  , value : x.categoryCode, 
          labelfr : x.categoryName.fr, labelar : x.categoryName.ar,
          features : x.features, unit : x.unit
        }
      })
  
    const [features, setFeatures] = useState({featureCode : "", en : "", fr : "", ar : "", unit : "", valueRange : [], reqid :""})
    const [categories, setCategories] = useState({categoryCode : "", en : "", fr : "", ar : ""})

    
    const [showvr, setShowvr] = useState(false)
 

    const [showProcessing , setShowProcessing] = useState(false)
    
    const [valrange, setValRange] = useState({vrid : "", len : "", lfr : "", lar : "", hen : "", hfr :"", har : ""})
    const [updatevalrange, setUpdatevalrange] = useState(false)
    const [sbut, showSbut] = useState(false)
    const [{alt, src}, setImg] = useState({
        src: dp,
        alt: ''
      });
      const [filenames, setFilenames] = useState()
      
      useEffect(() => {
        dispatch(featureFetch())
      },[])
      
    useEffect(() => {
      // setSelectedBrand({value : props.vehicle.bid, value : props.vehicle.bname.en})
      
      setCategories({categoryCode : props.features.categoryCode, en : props.features.categoryName.en , fr : props.features.categoryName.fr, ar : props.features.categoryName.ar})
      updf()
    }, [props.features])

    const updf = () => {
      try{
        setFeatures(props.features.features[0])
        showSbut(true)
      }catch(e){
        setFeatures(props.features)
        showSbut(false)
      }
    }

      const cinputConfirmAlert = (xcc) => {
        let mtext = ""
        if(features.featureCode === "" && categories.categoryCode !== ""){
            //Create new feature
            mtext ="Create new feature"
            props.swal({
              title: "Are you sure?",
              text: mtext,
              icon: "warning",
              dangerMode: true,
            })
            .then(willDelete => {
              if (willDelete) {
                createFeature()
              }
            });
           
        }else if(features.featureCode !== "" && categories.categoryCode !== ""){
 //Create new feature
            mtext ="Update feature"
            props.swal({
              title: "Are you sure?",
              text: mtext,
              icon: "warning",
              dangerMode: true,
            })
            .then(willDelete => {
              if (willDelete) {
                createFeature()
              }
            });
            
        }
       
      };  

 
      const createFeature = () => {
      setShowProcessing(true)
          let formData = new FormData(); 
          formData.append("featurelogo" , filenames)
          formData.append("categories", JSON.stringify(categories) );
          formData.append("features", JSON.stringify(features) );
          props.API({
            method: "post",
            url : `ten/createfeaturereq`,
            data: formData
            }).then((res) => {
            props.swal("Feature Requested!")
              setShowProcessing(false)

              dispatch(featureFetch())
            //  window.location.reload(false)
            }).catch(function (error) {
              setShowProcessing(false)
              
        }) 
  
      }

      const updImg = (e) => {
       if(features.en !== ""){
       setShowProcessing(true)
        let formData = new FormData(); 
        formData.append("featurelogo" , e.target.files[0])
        formData.append("categories", JSON.stringify(categories) );
        formData.append("features", JSON.stringify(features) );
        
        props.API({
          method: "post",
          url : `tenant/fimageupd`,
          data: formData
          }).then((res) => {
            props.swal("Feature Updated!")
            setShowProcessing(false)
            dispatch(featureFetch())
            window.location.reload(false)
          }).catch(function (error) {
            setShowProcessing(false)
             console.log("error")
      })
       }
       
      }

      const createRv = () => {
      
        let maxnumber = 0
            
        if(features.valueRange.length >=1) {
            maxnumber =  Math.max(...features.valueRange.map(o => Number(o.vrid))) + 1 
        }
        if(valrange.len ===""){
          setValRange({vrid : "", len : "", lfr : "", lar : "", hen : "", hfr :"", har : ""}) 
          return
        }
        let newvalr = {vrid : String(maxnumber) , len : valrange.len, lfr : "", lar : "", hen : valrange.hen, hfr :"", har : ""} 
        setValRange({vrid : String(maxnumber) , len : valrange.len, lfr : "", lar : "", hen : valrange.hen, hfr :"", har : ""}) 

   
        let lengthofval =  features.valueRange.find(f => f.len === newvalr.len)
        console.log(lengthofval)
        if(lengthofval === undefined){
          let newf = {...features , actions : ""}
          newf.valueRange.push(newvalr)   
          setFeatures(newf)
          
        }else{
          
          setValRange({vrid : "" , len : "", lfr : "", lar : "", hen : "", hfr :"", har : ""}) 
          return
        }
        
        
      }
    

      // this model alow you view and update value range for features..
      const valueRange = () => {
      
        return(
            <Modal isOpen={showvr}>
                <ModalHeader toggle={() => setShowvr(!showvr)}>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Row>
                                <Col><label style={{marginTop  :5}}>Value : </label></Col>
                                <Col><Input type = "text" placeholder="Min" value={valrange.len}
                                      onChange={x => {
                                          setValRange({...valrange, len : x.target.value})
                                      }}
                                /></Col>
                             
                                <Col><Button size="sm" style={{marginTop  : 2}} onClick={g => {createRv()}}> {updatevalrange ? "Update" : "Add"}</Button></Col>
                            </Row>
                        </Col>
                    </Row>
              
                </ModalBody>
            </Modal>
        )
        
      }
      
      const returnfunction = () => {
        try {
         
          return  <FeaturesList features={features.features[0]} setFeatures={setFeatures} API={props.API} sbut={sbut}/>
        }catch(e){
            return (
              <FeaturesList features={features} setFeatures={setFeatures} API={props.API} sbut={sbut}/>
            )
        }
      }


    
const handleImg = (e) => {
        
        if(e.target.files[0]) {
                
            if(filenamevalid(e.target.files[0])){
              setFilenames(e.target.files[0])
              setImg({
                src: URL.createObjectURL(e.target.files[0]),
                alt: e.target.files[0].name
            });
            updImg(e)
            }else{
              props.basicAlert("Invalid Filename")
            }
            
        
        }   
    }
    
     return (
      
        <div className="content">
             
             {showProcessing && props.Spin}
             {valueRange()}
             <input
                ref={hiddenFileInput}
                type="file" 
                accept=".png, .jpg, .jpeg" 
                id="photo" 
                className="visually-hidden"
                onChange={e=> handleImg(e)}
                hidden/>

        <Row>
            {/** This will contain Table */}
            <Col sm="12" md="5">
             
             <Card>
                 <CardHeader>
                 <Row>
                         <Col >
                         <FormGroup>
                               <label>Select Catagory </label>
                                     <Select options={catlist} styles={customStyles} 
                                            value={{label : categories.en + ' ' + categories.ar, value : categories.cityCode}} 
                                            onChange={e=> {
                                                    setCategories({categoryCode: e.value, en: e.label, fr: e.labelfr, ar: e.labelar});
                                                   
                                                    setFeatures({featureCode : "", en : "", fr : "", ar : "", unit : "" , valueRange : []})      
                                                    }}
                                            />
                               
                         </FormGroup>
                      
                         </Col>
                 </Row>
       
               <Row>
                <Col>
                <h6 style={{marginTop : 10}} >Feature {features.featureCode !== "" && " Code : " +  features.featureCode} </h6> 
                </Col>
               <Col>
               <span style={{float : "right"}}>
                        <img
                                    alt="..."
                                    width={"40px"}
                                    src={src}
                                    style={{ cursor : "pointer"}} 
                                    
                                />
                 </span>
               </Col>
               </Row>
                 
                
                 <Row >
                        <Col className="pr-1" md="4">
                        <FormGroup>
                             <label>Unit</label>
                             <Input
                             value={features.unit}
                             placeholder="en"
                             type="text"
                             onChange = {x => {
                                setFeatures({...features , unit : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>
                         <Col className="pr-1" md="4">
                      
                         <FormGroup>
                             <label>Name EN</label>
                             <Input
                             value={features.en}
                             placeholder="en"
                             type="text"
                             onChange = {x => {
                                setFeatures({...features , en : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>{/**  
                         <Col className="pr-1" md="3">
                         <FormGroup>
                             <label>Nom</label>
                             <Input
                              value={features.fr}
                             placeholder="Nom"
                             type="text"
                             onChange = {x => {
                                setFeatures({...features , fr : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>*/}
                         <Col className="pr-1" md="4">
                         <FormGroup>
                             <label>اسم</label>
                             <Input
                              value={features.ar}
                             placeholder="اسم"
                             type="text"
                             onChange = {x => {
                                setFeatures({...features , ar : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>
                 </Row>
             
                 </CardHeader>
                 <CardBody>
               
                 </CardBody>
                 <CardFooter>
                     <Button size="sm" color="warning" style={{float : "right", display : sbut ? "none" : "block"}} onClick={x => {
                        cinputConfirmAlert()
                     }}>Request</Button>
                 </CardFooter>
             </Card>
         </Col>
         <Col sm="12" md="7">
            <Card>
                <CardBody>
             <Row>
                <Col><h5>Add Values</h5></Col>
                <Col><i className="fa fa-plus" aria-hidden="true" style={{float : "right", display : props.features.reqid !== "" ? "none": "block"}} onClick={o => setShowvr(true)}></i></Col>
                </Row>
                <Row>
                    <Col>

                    {returnfunction()}
                    
                    </Col>
                </Row>
                </CardBody>
                </Card>
            </Col>
           
        </Row>
        </div>
    )
}

export default Features;